// index.js
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/app';

ReactDOM.render(<App />, window.document.querySelector('#root'));
